let { monkey } = require('baobab');
let _ = require('lodash');
const COMPONENTS = require('../compositions/layout');

module.exports = {
    /**
     * Устанавилваем компоненты специфичные для определенной вкладки
     * @param {Object} args
     * @param {Object} state
     */
    setComponentsByLink (args, state) {
        state.set(['page', 'components'], monkey(
            ['page', 'name'],
            ['user', 'role'],
            (page, role) => _.get(COMPONENTS, `${role}.${page}`)
        ));
    },

    setIsLoading (value) {
        return (args, state) => state.set('isLoading', value);
    }
};



// WEBPACK FOOTER //
// ./actions/layout/content.js